import { V2Shell } from "@/v2/components/V2Shell";
import { SidebarLayout } from "@/v2/components/layout/SidebarLayout";
import { Clock } from "lucide-react";

interface AccountComingSoonProps {
  title: string;
  description?: string;
}

/**
 * Placeholder account page rendered inside the same V2Shell + SidebarLayout as
 * Profile and Favorites Manager, so the sidebar nav links resolve to a real
 * (labelled "Coming soon") screen instead of a blank no-match route.
 */
export default function AccountComingSoon({
  title,
  description,
}: AccountComingSoonProps) {
  return (
    <V2Shell>
      <SidebarLayout>
        <div className="mx-auto flex h-full max-w-2xl flex-col items-center justify-center px-6 py-16 text-center">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-action/10">
            <Clock className="h-8 w-8 text-action" strokeWidth={1.75} />
          </div>
          <span className="mb-2 text-[12px] font-semibold uppercase tracking-wide text-action">
            Coming soon
          </span>
          <h1 className="mb-3 text-2xl font-bold text-slate-900">{title}</h1>
          <p className="max-w-md text-[15px] leading-relaxed text-slate-500">
            {description ??
              "We're still building this page. It'll be available here soon."}
          </p>
        </div>
      </SidebarLayout>
    </V2Shell>
  );
}
